import {IMenuItem} from "../interfaces/IMenuItem";

export interface OnCourseContext {
    onCourse: boolean;
    hole: number | null;
}

export const resolveOnCourseContext = (
    onCourseParam: string | null,
    holeParam: string | null
): OnCourseContext => {
    const onCourse = onCourseParam?.trim().toLowerCase() === 'true';
    if (!onCourse) {
        return {onCourse: false, hole: null};
    }

    const normalizedHole = holeParam?.trim() ?? '';
    const parsedHole = normalizedHole === '' ? Number.NaN : Number(normalizedHole);
    const hole = Number.isInteger(parsedHole) && parsedHole >= 1 && parsedHole <= 18
        ? parsedHole
        : null;

    return {onCourse: true, hole};
};

export const isMenuItemAvailable = (menuItem: IMenuItem, onCourse: boolean): boolean =>
    menuItem.active && (!onCourse || menuItem.onCourse === true);
